import { handleErrMessage } from "../../functions/handleErrMessage";
import { X, Check } from "lucide-react";


function StatusMessage({ isSucceed, formError }) {
  return (
    <>
      {isSucceed && (
        <div className="remark-msg">
       <Check color="#00a36c" />
          <p className="text-green-3 pl-2">Remark Successfully Deleted !</p>
        </div>
      )}
      {formError && (
        <div className="remark-msg">
           <X color="red"/>
          <p className="text-red-600 pl-2">{handleErrMessage(formError)}</p>
        </div>
      )}
    </>
  );
}

export default StatusMessage;
